import _objectSpread from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _slicedToArray from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/var/lib/jenkins/workspace/enrich-prod-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useContext } from 'react';
import { useDropdownToggle } from '@restart/ui/DropdownToggle';
import DropdownContext from '@restart/ui/DropdownContext';
import useMergedRefs from '@restart/hooks/useMergedRefs';
import Button from './Button';
import InputGroupContext from './InputGroupContext';
import { useBootstrapPrefix } from './ThemeProvider';
import useWrappedRefWithWarning from './useWrappedRefWithWarning';
import { jsx as _jsx } from "react/jsx-runtime";
var DropdownToggle = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    split = _ref.split,
    className = _ref.className,
    childBsPrefix = _ref.childBsPrefix,
    _ref$as = _ref.as,
    Component = _ref$as === void 0 ? Button : _ref$as,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "split", "className", "childBsPrefix", "as"]);
  var prefix = useBootstrapPrefix(bsPrefix, 'dropdown-toggle');
  var dropdownContext = useContext(DropdownContext);
  var isInputGroup = useContext(InputGroupContext);
  if (childBsPrefix !== undefined) {
    props.bsPrefix = childBsPrefix;
  }
  var _useDropdownToggle = useDropdownToggle(),
    _useDropdownToggle2 = _slicedToArray(_useDropdownToggle, 1),
    toggleProps = _useDropdownToggle2[0];
  toggleProps.ref = useMergedRefs(toggleProps.ref, useWrappedRefWithWarning(ref, 'DropdownToggle')); // This intentionally forwards size and variant (if set) to the
  // underlying component, to allow it to render size and style variants.

  return /*#__PURE__*/_jsx(Component, _objectSpread({
    className: classNames(className, prefix, split && "".concat(prefix, "-split"), !!isInputGroup && (dropdownContext == null ? void 0 : dropdownContext.show) && 'show')
  }, toggleProps, props));
});
DropdownToggle.displayName = 'DropdownToggle';
export default DropdownToggle;